import { getRenderTimeZone } from "@clockwise/web-commons/src/util/time-zone.util";
import { DateTime } from "luxon";

const isAfternoon = (now: DateTime) => {
  return now.hour >= 12 && now.hour < 17;
};
const isMorning = (now: DateTime) => {
  return now.hour < 12;
};

export const getRelativeTimeOfDayString = (dateTime: DateTime) => {
  const timeZone = getRenderTimeZone();
  const now = dateTime.setLocale(timeZone);

  if (isMorning(now)) {
    return "morning";
  } else if (isAfternoon(now)) {
    return "afternoon";
  } else {
    return "evening";
  }
};
